import * as React from "react";

function SvgSettings(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 48 48" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M31.48 24a7.083 7.083 0 11-14.167 0 7.083 7.083 0 0114.167 0zm-2.834 0a4.25 4.25 0 11-8.5 0 4.25 4.25 0 018.5 0z"
        fill="#fff"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M37.009 22.12l3.784-2.626a16.89 16.89 0 00-1.511-3.711l-.31-.538a17.067 17.067 0 00-2.48-3.19l-4.163 1.963a12.74 12.74 0 00-3.255-1.883l-.382-4.588A17.028 17.028 0 0024.396 7c-1.231 0-2.432.13-3.589.38l-.57 4.564a12.725 12.725 0 00-3.774 2.074L12.3 12.055a17.071 17.071 0 00-2.478 3.19l-.312.538a16.903 16.903 0 00-1.303 3.014l3.67 2.778a12.821 12.821 0 00-.093 4.305L8 28.506c.358 1.307.869 2.55 1.51 3.711l.311.538a17.053 17.053 0 001.98 2.662l4.238-1.788c1.082.94 2.324 1.7 3.68 2.236l.382 4.588c1.372.357 2.811.547 4.295.547s2.924-.19 4.296-.547l.382-4.589a12.738 12.738 0 003.255-1.882l4.164 1.962a17.066 17.066 0 002.479-3.19l.31-.536a16.89 16.89 0 001.51-3.712L37.01 25.88a12.862 12.862 0 000-3.76zM32.896 24a8.5 8.5 0 11-17 0 8.5 8.5 0 0117 0z"
        fill="#fff"
      />
    </svg>
  );
}

export default SvgSettings;
